/**
 * Lightweight journey tracker for the VG2 B2C flow.
 * Stores tools completed + email in localStorage so cards on /app can
 * show progress (1/3, 2/3, 3/3) and the next-tool CTA can carry email + ref.
 */
const KEY = "vg_journey_v1";

const DEFAULT = { email: "", nome: "", tools: {} };

export function getJourney() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return { ...DEFAULT };
    return { email: parsed.email || "", nome: parsed.nome || "", tools: parsed.tools || {} };
  } catch {
    return { ...DEFAULT };
  }
}

export function markToolCompleted(tool, { email = "", nome = "", journey_id = null, modalita = null } = {}) {
  const j = getJourney();
  const emailLc = (email || j.email || "").toLowerCase();
  const prevTool = j.tools?.[tool] || {};
  const nextModalita = modalita || prevTool.modalita || null;
  const next = {
    email: emailLc,
    nome: nome || j.nome || "",
    tools: {
      ...j.tools,
      [tool]: {
        completed_at: new Date().toISOString(),
        journey_id: journey_id || (prevTool.journey_id ?? null),
        modalita: nextModalita,
      },
    },
  };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore quota errors
  }
  return next;
}

export function countCompleted() {
  const j = getJourney();
  return Object.keys(j.tools || {}).length;
}

export function isToolCompleted(tool) {
  const j = getJourney();
  return !!(j.tools && j.tools[tool]);
}

export function clearJourney() {
  try { localStorage.removeItem(KEY); } catch { /* noop */ }
}
